import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// Importación de componentes

import { HomeComponent } from "./componentes/home/home.component";
import { PedirCitaComponent } from "./componentes/citas/pedircita.component";
import { VerCitasComponent } from "./componentes/citas/vercitas.component";
import { InfoAreasComponent } from "./componentes/informacion/infoareas.component";
import { InfoTramitesComponent } from "./componentes/informacion/infotramites.component";
import { Pagina404Component } from "./componentes/errores/pagina-404.component";
//import { AppAnalizaUrl } from './componentes/errores/analizaurl.component';
import { Pagina500Component } from "./componentes/errores/pagina-500.component";
import { ClienteNoValidoComponent } from "./componentes/errores/cliente-no-valido.component";

import { AuthenticationGuard } from "app/authentication.guard";

const appRoutes: Routes = [
  { path: "", component: HomeComponent },
  {
    path: "citas",
    component: PedirCitaComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: "vercitas",
    component: VerCitasComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: "infoareas",
    component: InfoAreasComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: "infotramites",
    component: InfoTramitesComponent,
    canActivate: [AuthenticationGuard],
  },
  { path: "cliente-no-valido", component: ClienteNoValidoComponent },
  { path: "404", component: Pagina404Component },
  { path: "500", component: Pagina500Component },
  { path: "**", component: Pagina404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule],
})
export class routing {}
